import { createContext } from 'react';
import { TLanguageIDs, IDishPortionForGetInfo, IItemForGetShortInfo } from 'types';

export interface IViewPortionState {
	portionFullInfo: Nullable<IDishPortionForGetInfo>;
	portionModifierGroupId: Nullable<string>;
	portionModifierGroupModifiers: IItemForGetShortInfo[];
	selectedTranslationTab: Nullable<TLanguageIDs>;
}

export const viewPortionInitialState: IViewPortionState = {
	portionFullInfo: null,
	portionModifierGroupId: null,
	portionModifierGroupModifiers: [],
	selectedTranslationTab: null,
};

export interface IViewPortionContext extends IViewPortionState {
	setTranslationTab(value: Nullable<TLanguageIDs>): void;
	setPortionModifierGroupId(value: Nullable<string>): void;
}

export const ViewPortionContext = createContext<IViewPortionContext>({
	setTranslationTab: () => undefined,
	setPortionModifierGroupId: () => undefined,
	...viewPortionInitialState,
});
